import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateProfessionalManagementUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateProfessionalManagement
  implements UpdateProfessionalManagementUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<UpdateProfessionalManagementUseCaseInterface.Result>,
  ) {}

  async execute(
    params: UpdateProfessionalManagementUseCaseInterface.Params,
  ): Promise<UpdateProfessionalManagementUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'put',
      url: this.url + '/' + params.id + '/' + params.professionalType,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
